/* sm-hero-lifandi-2.js - afrit af sm-hero-lifandi.js fyrir sections/sm-hero-lifandi-2.liquid (17.10.2026, yfirferd/hero-impeccable-2026-10-17/).
   Fjórar breytingar, merktar [hx]: tvö sýninöfn (Lítið) í stað fjögurra, platan um 7 % stærri í svæðinu, einn aðaltakki á öllum
   breiddum (sami og síminn hafði) og aðaltakkinn fylgir flipanum án innsláttar. Vélar, localStorage-lyklar og slóðarbreytur óbreytt.
   Upphaflega: lifandi flís í hero forsíðu B (sections/sm-hero-lifandi.liquid). ES5.
   Upphaflega 15.10.2026 (yfirferd/forsida-b-2026-10-15/), endurskrifað 15.10.2026 (yfirferd/forsida-b-hero-lifandi-2026-10-15/):
   allir fjórir fliparnir eru LIFANDI og keyra sömu vélar og vörusíðurnar:
     hurd  = hurðaskiltavélin (window.SMHurd úr sm-hurd-vel.js, hlaðin með síðunni) á atlas-ljósmyndum akrýlsins.
             Komma EÐA Enter gefur nýja línu (reiturinn er textarea), stærðin fylgir fjölda nafna eins og á vörusíðunni:
             1-2 Lítið, 3-5 Mið, 6+ Stórt; án nafna Mið með sýninöfnum vélarinnar.
     hus   = húsnúmeravélin (sm-husnumer.js + sm-husnumer.css, sama ræsing og sm-vs-husnumer.js á vörusíðunni: [data-hn] með
             vörugögnum, E.teiknaForskodun), plata með númeri og götu. "28 Kirkjustræti" eða "Kirkjustræti 28".
     hotel = herbergisnúmeravélin (window.SMHerb úr sm-herbergi-vel.js, uppsetning + teikna), HERBERGI · ROOM undir.
     gjof  = Owala brúsavélin (window.SMBrusiVel úr sm-brusi-vel.js, svgAf), allur brúsinn liggjandi svo nafnið lesist.
   Vélar hinna flipanna hlaðast AÐEINS þegar flipinn er valinn (eða músin fer yfir hann / hann fær fókus), svo forsíðan
   þyngist ekki. Meðan vélin hleðst stendur kyrra myndin í sama ramma (ekkert hoppar).
   Einn innsláttarreitur: heiti, sýnishorn og hjálp skipta um merkingu eftir flipa; gildið helst í hverjum flipa og nafnið
   fer á milli Hurðar og Gjafar ef hinn er tómur.
   Það sem gesturinn skrifaði fer ALDREI í slóð (M3): við smell er það geymt í localStorage, einn lykill á flipa svo gömul
   færsla eins flipa lendi ekki á annarri vöru, og tengillinn ber aðeins lýsandi valkosti vörunnar (lit, gerð, stærð, letur)
   og fra=forsida. Vörusíðan les sinn lykil einu sinni, aðeins með fra=forsida og innan 30 mín, og eyðir honum:
     hurd  'sm-forsida-nafn'  = {n, s, t}      sm-vs-hurd.js
     hus   'sm-forsida-hus'   = {numer, gata, t} sm-vs-husnumer.js (þáttað hér: "28 Kirkjustræti" = 28 + Kirkjustræti)
     hotel 'sm-forsida-hotel' = {numer, t}     sm-vs-herbergi.js
     gjof  'sm-forsida-gjof'  = {nafn, t}      sm-vs-brusi.js (letrið fer í slóð sem letur=bebas|quicksand|dancing)
   Á síma (1000 px og mjórra) er aðeins einn aðaltakki: aðaltakkinn verður "Hanna þetta skilti" (eða texti flipans) þegar
   eitthvað er skrifað, og tengillinn í flísinni felur sig. Einkunnartengillinn (#umsagnir) fær umsagnakaflann sem mark. */
(function () {
  'use strict';
  var KVARDI = { S: 'Lítið, 5 x 12 cm', M: 'Mið, 7,5 x 12 cm', L: 'Stórt, 10 x 12 cm' };
  var MMH = { S: 50, M: 75, L: 100 };
  /* Enska (/en): orðin í stærðarlínunni koma úr [data-hl-ord] (aðeins á ensku); íslensk hegðun óbreytt */
  var ORD = {};
  try { var oe = document.querySelector('[data-hl-ord]'); if (oe) ORD = JSON.parse(oe.textContent) || {}; } catch (e) { ORD = {}; }
  function kvEn(t) {
    if (!ORD.mid) return t;
    return String(t).replace(/Lítið/g, ORD.lit).replace(/Mið/g, ORD.mid).replace(/Stórt/g, ORD.stort).replace(/(\d),(\d)/g, '$1.$2');
  }
  var LYKILL = 'sm-forsida-nafn';
  var LYKLAR = { hus: 'sm-forsida-hus', hotel: 'sm-forsida-hotel', gjof: 'sm-forsida-gjof' };
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function trim(t) { return String(t == null ? '' : t).replace(/^\s+|\s+$/g, ''); }
  function nofnAf(t) {
    return String(t || '').split(/[,\n]/).map(trim).filter(Boolean).slice(0, 10);
  }
  function einLina(t) { return trim(String(t || '').replace(/\s+/g, ' ')); }
  /* Hús: "5 L" er númer 5 og gata L: bókstafur tilheyrir númerinu aðeins ef hann er fastur við það ("12B Kirkjubraut");
     "Kirkjubraut 5" les sama. Sama þáttun í teikningu og í því sem fer yfir á vörusíðuna. */
  function lesaHus(gildi) {
    var t = einLina(gildi), m;
    if ((m = /^(\d+[a-zA-Z]?)(?:\s+(.*))?$/.exec(t))) return { numer: m[1], gata: m[2] || '' };
    if ((m = /^(.*?)\s+(\d+[a-zA-Z]?)$/.exec(t))) return { numer: m[2], gata: m[1] };
    return { numer: '', gata: t };
  }

  /* ---- lazy hleðsla ---- */
  var skriftir = {};
  function hladaSkrift(url, glob) {
    if (glob && window[glob]) return Promise.resolve(window[glob]);
    if (skriftir[url]) return skriftir[url];
    skriftir[url] = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = url; s.async = true;
      s.onload = function () { res(glob ? window[glob] : true); };
      s.onerror = function () { delete skriftir[url]; rej(new Error(url)); };
      document.head.appendChild(s);
    });
    return skriftir[url];
  }
  var stilar = {};
  function hladaCss(url) {
    if (stilar[url]) return stilar[url];
    stilar[url] = new Promise(function (res) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = url;
      l.onload = l.onerror = function () { res(); };
      document.head.appendChild(l);
    });
    return stilar[url];
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ================= vélarnar ================= */

  /* Hurð: hurðaskiltavélin með sömu stillingum og vörusíðan (cfg.material, shape, border, skraut, font); stærðin fylgir fjölda
     nafna (Ál er ein stærð), mál plötunnar eins og mmPlata í sm-vs-hurd.js. Rammi aðeins á akrýl: á áli, stáli og messing er
     enginn Rammi-valkostur í vörunum í dag (vantarRamma í sm-vs-hurd.js), svo hann er hvorki sýndur né teiknaður þar. */
  var AKRYL = { gold: 1, white: 1, silver: 1, black: 1 };
  var leturKomid = {};
  function hladaVefletur(fjolsk, thykkt) {
    var k = thykkt + ' ' + fjolsk;
    if (leturKomid[k]) return leturKomid[k];
    leturKomid[k] = (document.fonts && document.fonts.load) ? document.fonts.load(thykkt + ' 40px "' + fjolsk + '"', 'AaÁðÞæö') : Promise.resolve();
    return leturKomid[k];
  }
  function velHurd(lag, svid) {
    var hylki = lag.querySelector('[data-hl-plata]');
    if (!hylki || !window.SMHurd || !window.SMHurd.vel) return null;
    hylki.innerHTML = '<div class="vs-hurd-svid"><div class="vs-hurd-plata"><div data-hurd-sella>' +
      '<img class="vs-hurd-atlas" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="" draggable="false" decoding="async"><div class="vs-hurd-texti"></div></div></div></div>';
    var plata = hylki.querySelector('.vs-hurd-plata'), sella = plata.firstChild;
    var cfg = { material: 'gold', size: 'M', sizeManual: false, shape: 'rect', border: true, font: 'montserrat',
      names: '', address: '', includeAddress: false, notes: '', skraut: false, qty: 1 };
    var v;
    try {
      v = window.SMHurd.vel({ root: svid, plate: sella, plateImg: sella.firstChild, plateText: sella.lastChild,
        D: { variants: [], options: [], handle: 'hurdaskilti-akryl', family: 'akryl' }, cfg: cfg });
    } catch (e) { return null; }
    var tilbuin = false;
    var V = {
      kvardi: KVARDI.S, /* [hx] tómur reitur = Lítið með tveimur sýninöfnum */
      tilbuin: function () { return tilbuin; },
      teikna: function (gildi, val) {
        if (!tilbuin) return;
        val = val || {};
        var mat = v.MAT[val.efni] ? val.efni : 'gold', M = v.MAT[mat];
        var F = v.FONTS[val.letur] ? val.letur : 'montserrat', Fd = v.FONTS[F];
        /* letrið verður að vera komið áður en vélin mælir textann; annars er teiknað aftur þegar það kemur */
        var fj = /"([^"]+)"/.exec(Fd.css);
        if (fj && document.fonts && document.fonts.check && !document.fonts.check(Fd.w + ' 40px "' + fj[1] + '"')) {
          hladaVefletur(fj[1], Fd.w).then(function () { if (V.endurteikna) V.endurteikna(); });
          if (F !== cfg.font) return;
        }
        var L = nofnAf(gildi);
        cfg.names = L.join('\n');
        cfg.material = mat;
        v.D.family = M.fam;
        cfg.shape = (!M.noOval && AKRYL[mat] && val.logun === 'oval') ? 'oval' : 'rect';
        cfg.border = AKRYL[mat] ? val.rammi !== false : false;
        cfg.skraut = !!val.skraut;
        cfg.font = F;
        cfg.size = M.fixedSize || (!L.length ? 'S' : (L.length <= 2 ? 'S' : (L.length <= 5 ? 'M' : 'L'))); /* [hx] tómt = S: tvö sýninöfn, platan hoppar ekki við fyrsta nafn */
        var oval = cfg.shape === 'oval';
        var g = oval ? ((v.FRAM && v.FRAM.oval && v.FRAM.oval[cfg.size]) || v.OVAL_GEO[cfg.size] || v.OVAL_GEO.M) : (v.RECT_GEO[cfg.size] || v.RECT_GEO.M);
        var r = hylki.getBoundingClientRect();
        if (r.width < 20 || r.height < 20) return;
        var mw = (oval || cfg.size === 'AL') ? 150 : 120, mh = { S: 50, M: 75, L: 100, AL: 75 }[cfg.size] || 75;
        /* einn kvarði fyrir Lítið og Mið (Mið fyllir svæðið), Stórt minnkar svo það rúmist; stærðin stendur undir */
        var kv = Math.min(r.width * 0.92 / mw, r.height * 0.92 / Math.max(mh, 75)); /* [hx] 0,86 -> 0,92 */
        var pw = kv * mw, ph = pw / (g.width / g.height), W = pw / g.width;
        plata.style.width = pw + 'px';
        plata.style.height = ph + 'px';
        plata.style.borderRadius = oval ? '50%' : (1.5 / mw * 100) + '%/' + (1.5 / mh * 100) + '%';
        sella.style.width = W + 'px';
        sella.style.height = W + 'px';
        sella.style.left = (-(1 - g.width) / 2 * W) + 'px';
        sella.style.top = (-g.top * W) + 'px';
        try { v.renderPlate(); } catch (e) { return; }
        var S = v.SIZES[cfg.size];
        V.size = cfg.size; V.oval = oval; /* [P1 23.10] stærðin fer í slóð aðaltakkans (staerd=) */
        V.kvardi = S ? S.name + ', ' + String(oval ? S.oval : S.dim).replace(/\s*×\s*/, ' x ') + ' cm' : KVARDI.M;
      }
    };
    /* vélin birtist þegar letrið og ljósmynd plötunnar (sjálfgefið gull) eru komin; ekkert annað stendur í staðinn */
    V.hladid = Promise.all([
      hladaVefletur('Montserrat', 500),
      new Promise(function (res) { var im = new Image(); im.onload = im.onerror = function () { res(); }; im.src = svid.getAttribute('data-atlas-rect-gold'); })
    ]).then(function () {
      tilbuin = true;
      hylki.hidden = false;
      lag.classList.add('is-lifandi');
      return V;
    });
    return V;
  }

  /* Hús: húsnúmeravélin ræst eins og á vörusíðunni (sm-vs-husnumer.js): [data-hn] með vörugögnunum, svo sm-husnumer.js */
  function velHus(lag, svid, sl, flipi) {
    var hylki = lag.querySelector('[data-hl-vel]'), kyrr = lag.querySelector('[data-hl-kyrr]');
    var handle = flipi.getAttribute('data-handle') || 'husnumer-og-heimilisfang-akryl';
    var E = null, fl = null;
    var V = { kvardi: '', tilbuin: function () { return !!E; } };
    /* gatan birtist um leið og fyrsti stafur hennar kemur (lesaHus efst) */
    V.lesa = lesaHus;
    V.teikna = function (gildi, val) {
      if (!E) return;
      val = val || {};
      var x = V.lesa(gildi), numer = x.numer, gata = x.gata;
      E.s.gerd = 'addr';
      E.s.hattur = 'gata';
      if (val.litur) E.s.litur = val.litur + ' - ' + (val.aferd || 'glans');
      if (val.staerd && E.PLOTUSTAERD[val.staerd]) E.s.staerd = val.staerd;
      E.s.numer = E.hreinsaNumer(numer.replace(/\s/g, ''), 'addr').gildi;
      E.s.texti = trim(gata).slice(0, 24);
      if (fl) fl.setAttribute('data-fin', E.litur().fin);
      try { E.teiknaForskodun(); } catch (e) {}
      V.kvardi = String(E.s.staerd || '14 x 14cm').replace(/\s*cm$/, ' cm');
    };
    V.hladid = Promise.all([
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }),
      hladaCss(sl.hnCss)
    ]).then(function (r) {
      var p = r[0], lag2 = 0;
      var afb = (p.variants || []).map(function (a) { if (!lag2 || a.price < lag2) lag2 = a.price; return { id: a.id, g: (a.options || []).slice(), verd: a.price, til: !!a.available }; });
      var gogn = { addr: { id: p.id, handle: p.handle, title: p.title, url: p.url, lagmark: lag2,
        valkostir: (p.options || []).map(function (o) { return o && o.name ? o.name : o; }), afbrigdi: afb } };
      hylki.innerHTML = '<div class="pdp-hn hl-hn" data-hn data-hn-byrjun="addr" aria-hidden="true">' +
        '<script type="application/json" data-hn-gogn>' + JSON.stringify(gogn).replace(/</g, '\\u003c') + '</script>' +
        '<div class="hn-staerd-mynd hl-hn-flotur" data-hl-hn-flotur data-fin="svart-glans"><div class="hn-veggur hl-hn-veggur" data-hn-veggur>' +
        '<div class="hn-carved" data-hn-carved hidden aria-hidden="true"><span class="hn-carved-row" data-hn-carved-row></span></div>' +
        '<div class="hn-plata" data-hn-plata hidden aria-hidden="true"><span class="hn-plata-num" data-hn-num></span><span class="hn-plata-rule" data-hn-rule hidden></span><span class="hn-plata-texti" data-hn-texti hidden></span></div>' +
        '</div></div><div class="hl-hn-krot" style="position:absolute;left:-400000px;top:0;visibility:hidden;pointer-events:none"></div></div>';
      fl = hylki.querySelector('[data-hl-hn-flotur]');
      hylki.hidden = false;
      return hladaSkrift(sl.hnJs, 'SMHusnumer');
    }).then(function (H) {
      if (!H || !H.teiknaForskodun) throw new Error('SMHusnumer');
      E = H;
      if (kyrr) kyrr.hidden = true;
      lag.classList.add('is-lifandi');
      return V;
    });
    return V;
  }

  /* Hótel: herbergisnúmeravélin. Á skornu efni (hnota, akrýl) kemst HERBERGI · ROOM ekki fyrir (skorinn texti minnst 10 mm),
     svo hér er tvílitt grafið gull, 14 x 14 cm, með ramma (FRAME RULE: sjálfgefið á tvílitu) eins og vörusíðan býður. */
  var HOTEL = { gerd: 'tvilitt', staerd: '140x140', festing: 'lim', plata: 'svart-matt', bak: 'hvitt-glans', litur: 'gull', letur: 'reo',
    rammi: true, undir: 'HERBERGI · ROOM', hamarkB: 0.62, hamarkH: 0.28 };
  function velHotel(lag, svid, sl) {
    var hylki = lag.querySelector('[data-hl-vel]'), kyrr = lag.querySelector('[data-hl-kyrr]');
    var H = null;
    var V = { kvardi: '', villa: false, tilbuin: function () { return !!H; } };
    var didot = null;
    V.teikna = function (gildi, val) {
      if (!H) return;
      val = val || {};
      var tx = H.hreinsa(trim(String(gildi || '').replace(/\s+/g, ' ')));
      var e = {}, k;
      for (k in HOTEL) if (Object.prototype.hasOwnProperty.call(HOTEL, k)) e[k] = HOTEL[k];
      e.texti = tx || '204';
      if (val.litur && H.TVILITT[val.litur]) e.litur = val.litur;
      /* Klassískt (SM Didot) hleðst fyrst þegar það er valið; þangað til stendur síðasta teikning */
      if (val.letur === 'didot') {
        if (!didot) didot = H.hlada([H.LETUR.didot, H.LETUR_BRYR.didot], { opentype: sl.opentype, clipper: sl.clipper, letur: sl.didot || {} }).then(function () { if (V.endurteikna) V.endurteikna(); });
        if (!H.hefurLetur(H.LETUR.didot)) return;
        e.letur = 'didot';
        e.undir = ''; /* [P1 23.10] vörusíðan leyfir ekki HERBERGI · ROOM með Klassísku á 14 x 14 (undirIBodi), svo hero-ið lofar því ekki heldur */
      }
      var U = null;
      try { U = H.uppsetning(e); } catch (x) { U = null; }
      V.villa = !(U && U.ok);
      if (V.villa) return;
      var svg = H.teikna(U, { id: 'hlhb', slodir: {}, skuggi: true, bil: 8, aria: '' });
      hylki.innerHTML = svg;
      V.kvardi = (H.STAERDIR[e.staerd] && H.STAERDIR[e.staerd].heiti) || '';
    };
    V.hladid = hladaSkrift(sl.herbJs, 'SMHerb').then(function (h) {
      if (!h || !h.hlada) throw new Error('SMHerb');
      return h.hlada([h.LETUR.reo], { opentype: sl.opentype, clipper: sl.clipper, letur: { 'rounded-elegance-open': sl.reo } }).then(function () { return h; });
    }).then(function (h) {
      H = h;
      hylki.hidden = false;
      if (kyrr) kyrr.hidden = true;
      lag.classList.add('is-lifandi');
      return V;
    });
    return V;
  }

  /* Gjöf: Owala brúsavélin (svgAf), allur brúsinn liggjandi (botninn til vinstri) svo nafnið lesist frá vinstri til hægri */
  function velGjof(lag, svid, sl) {
    var hylki = lag.querySelector('[data-hl-vel]'), kyrr = lag.querySelector('[data-hl-kyrr]');
    var B = null, st = null;
    var V = { kvardi: '', tilbuin: function () { return !!B && B.leturKlar('bebas'); } };
    function stada(gildi, val) {
      val = val || {};
      return { staerd: val.staerd === '945' ? '945' : '710', litur: val.litur === 'hvitur' ? 'hvitur' : 'svartur', hamur: 'texti', texti: trim(String(gildi || '').replace(/\s+/g, ' ')),
        letur: { bebas: 1, quicksand: 1, dancing: 1 }[val.letur] ? val.letur : 'bebas', ts: 'M', ls: 'M',
        logo: null, logoSkra: null, logoVilla: '', logoGreinir: false, magn: 1, aths: '', reynt: false, snert: true };
    }
    V.teikna = function (gildi, val) {
      if (!V.tilbuin()) return;
      st = stada(gildi, val);
      if (!B.leturKlar(st.letur)) return;
      B.setjaSt(st);
      var r = hylki.getBoundingClientRect(), M = B.MYND_MM;
      if (r.width < 20) return;
      var svg = B.svgAf(st, { naer: false, ks: Math.max(0.5, Math.min(r.width / M.h, r.height / M.w)), id: 'hlbs' });
      var inn = svg.slice(svg.indexOf('>') + 1, svg.lastIndexOf('</svg>'));
      hylki.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + (-M.h) + ' 0 ' + M.h + ' ' + M.w + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false"><g transform="rotate(90)">' + inn + '</g></svg>';
    };
    V.hladid = hladaSkrift(sl.bsJs, 'SMBrusiVel').then(function (F) {
      if (!F) throw new Error('SMBrusiVel');
      var maeli = document.createElement('span');
      maeli.className = 'hl-bs-maeli';
      maeli.setAttribute('aria-hidden', 'true');
      maeli.setAttribute('data-bs-maeli', '');
      lag.appendChild(maeli);
      var G = { v: 1, vara: {}, hlutverk: ['staerd', 'litur'], kodar: { staerd: ['710', '945'], litur: ['svartur', 'hvitur'] },
        opts: [{ n: 'Stærð', v: ['710', '945'] }, { n: 'Litur', v: ['svartur', 'hvitur'] }], variants: [],
        slodir: { brusar: sl.bs || {}, stal: sl.bsStal, letur: sl.bsLetur || {} } };
      B = F(G, { syni: 'Anna' }, { rot: lag, render: function () { if (V.endurteikna) V.endurteikna(); } });
      B.setjaSt(stada('', {}));
      return B.hladaLetur();
    }).then(function () {
      if (!V.tilbuin()) throw new Error('letur');
      hylki.hidden = false;
      if (kyrr) kyrr.hidden = true;
      lag.classList.add('is-lifandi');
      return V;
    });
    return V;
  }

  var SMIDIR = { hurd: velHurd, hus: velHus, hotel: velHotel, gjof: velGjof };

  /* ================= flísin ================= */
  function hero(rot) {
    var flis = rot.querySelector('[data-hl-flis]');
    if (!flis) return;
    var sl = {};
    try { sl = JSON.parse(flis.querySelector('[data-hl-slodir]').textContent); } catch (e) { sl = {}; }
    var tabs = [].slice.call(flis.querySelectorAll('[data-hl-tab]'));
    var panel = flis.querySelector('[role="tabpanel"]'), svid = flis.querySelector('[data-hl-svid]');
    var kvardiEl = flis.querySelector('[data-hl-kvardi]'), reitur = flis.querySelector('[data-hl-nafn]');
    var heiti = flis.querySelector('[data-hl-heiti]'), hjalp = flis.querySelector('[data-hl-hjalp]');
    var afram = flis.querySelector('[data-hl-afram]'), aframTexti = flis.querySelector('[data-hl-afram-texti]');
    var takki = rot.querySelector('[data-hl-takki]'), tilkynna = flis.querySelector('[data-hl-tilkynna]');
    if (!svid || !reitur || !tabs.length) return;
    var mq = window.matchMedia ? window.matchMedia('(max-width: 1000px)') : null;
    var grunnT = takki ? takki.innerHTML : '', grunnH = takki ? takki.getAttribute('href') : '';
    var aTakka = false, virkur = tabs[0].getAttribute('data-hl-tab'), velar = {}, gildi = {}, villa = false, hledstEkki = {};
    var val = {};

    function flipiAf(k) { for (var i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('data-hl-tab') === k) return tabs[i]; return null; }
    function lagAf(k) { return svid.querySelector('[data-hl-lag="' + k + '"]'); }
    /* [bola] 22.10: með glerbólunni (data-hl-bola) á flipi TVO valkostahópa, litapunktana (.hx-val, undir reitnum) og bóluna (.vs-hurd-takkar,
       á veggnum); lesaVal les báða, valAf gefur litaröðina (skrunið á síma). Án bólunnar er hópurinn einn eins og áður. */
    function valAf(k) { return flis.querySelector('.hx-val[data-hl-val="' + k + '"]') || flis.querySelector('[data-hl-val="' + k + '"]'); }
    function valAllir(k) { return [].slice.call(flis.querySelectorAll('[data-hl-val="' + k + '"]')); }
    /* valkostir flipa k lesnir úr röðinni: litir/efni (radio), pör (aria-pressed), rofar og hringir; .slod = slóðargildin */
    function lesaVal(k) {
      var g = valAf(k), o = { slod: {} }, allir = valAllir(k);
      if (!g) { val[k] = o; return o; }
      g = { querySelectorAll: function (s) { var ut = []; allir.forEach(function (x) { ut = ut.concat([].slice.call(x.querySelectorAll(s))); }); return ut; } };
      [].slice.call(g.querySelectorAll('[data-hl-k]')).forEach(function (f) {
        var r = f.querySelector('input:checked'), n = f.getAttribute('data-hl-k');
        o[n] = r ? r.value : null; o.slod[n] = r ? r.getAttribute('data-slod') : null;
      });
      [].slice.call(g.querySelectorAll('[data-hl-par]')).forEach(function (p) {
        var b = p.querySelector('[aria-pressed="true"]'), n = p.getAttribute('data-hl-par');
        o[n] = b ? b.getAttribute('data-v') : null; o.slod[n] = b ? (b.getAttribute('data-slod') || b.getAttribute('data-v')) : null;
      });
      [].slice.call(g.querySelectorAll('[data-hl-rofi]')).forEach(function (b) { o[b.getAttribute('data-hl-rofi')] = b.getAttribute('aria-pressed') === 'true'; });
      [].slice.call(g.querySelectorAll('[data-hl-hringur]')).forEach(function (b) {
        var n = b.getAttribute('data-hl-hringur'), i = +(b.getAttribute('data-i') || 0);
        o[n] = (b.getAttribute('data-gildi') || '').split(',')[i] || null;
        o.slod[n] = (b.getAttribute('data-slod') || '').split(',')[i] || null;
      });
      /* hurð: lögun og rammi eru aðeins til á akrýl (vörurnar), annars falin */
      if (k === 'hurd') [].slice.call(g.querySelectorAll('[data-hl-akryl]')).forEach(function (x) { x.hidden = !AKRYL[o.efni]; });
      val[k] = o;
      return o;
    }
    tabs.forEach(function (t) { lesaVal(t.getAttribute('data-hl-tab')); gildi[t.getAttribute('data-hl-tab')] = ''; });

    function vel(k) {
      if (velar[k] !== undefined) return velar[k];
      var lag = lagAf(k), f = SMIDIR[k];
      velar[k] = (lag && f) ? f(lag, svid, sl, flipiAf(k)) : null;
      if (velar[k]) {
        /* meðan vélin hleðst er kyrra myndin dempuð; hlaðist hún ekki er það sagt í raufinni og tengillinn stendur */
        lag.classList.add('is-hledur');
        velar[k].endurteikna = function () { if (k === virkur) teikna(); };
        velar[k].hladid.then(function () { lag.classList.remove('is-hledur'); if (k === virkur) teikna(); }, function (e) {
          lag.classList.remove('is-hledur');
          hledstEkki[k] = true;
          if (k === virkur) syna();
          if (window.console) console.warn('sm-hero-lifandi: ' + k + ' ' + (e && e.message));
        });
      }
      return velar[k];
    }

    /* tengillinn á vöruna fyrir flipa k: aðeins lýsandi valkostir, aldrei það sem var skrifað */
    function rotSlod() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (location.pathname.indexOf('/en/') === 0 ? '/en/' : '/'); return r.replace(/\/$/, ''); }
    function slodAf(k) {
      var f = flipiAf(k);
      var o = val[k] || { slod: {} }, b = [];
      if (k === 'hurd') {
        /* sömu lýsandi breytur og sm-vs-hurd.js les: litur (akrýl), efni (málmar), rammi, letur; varan eftir efni og lögun */
        var akryl = !!AKRYL[o.efni], oval = akryl && o.logun === 'oval';
        var h = akryl ? (oval ? 'hurdaskilti-sporoskjulaga' : 'hurdaskilti-akryl') : (o.efni === 'aluminum' ? 'hurdaskilti-al' : 'hurdaskilti-stal-og-messing');
        if (akryl) b.push('litur=' + ({ gold: 'gull', white: 'hvitt', silver: 'silfur', black: 'svart' }[o.efni]), 'rammi=' + (o.rammi === false ? 'an' : 'med'));
        else b.push('efni=' + ({ aluminum: 'al', steel: 'stal-svartir', brass: 'messing' }[o.efni]), 'litur=' + ({ aluminum: 'al', steel: 'stal', brass: 'messing' }[o.efni]));
        /* [P1 23.10] stærðin sem vélin valdi eftir fjölda nafna fer með sem stutti lykill kittsins (B1 forval: staerd=5-12-cm o.s.frv.,
           sporöskja 15 cm, stál/messing "5 x 12cm"); ál hefur eina stærð */
        var Vh = velar.hurd, sz = Vh && Vh.tilbuin && Vh.tilbuin() && Vh.size;
        if (sz && o.efni !== 'aluminum') {
          var st = oval ? { S: '5-15-cm', M: '7-5-15-cm', L: '10-15-cm' } : (akryl ? { S: '5-12-cm', M: '7-5-12-cm', L: '10-12-cm' } : { S: '5-x-12cm', M: '7-5-x-12cm', L: '10-x-12cm' });
          if (st[sz]) b.push('staerd=' + st[sz]);
        }
        if (o.slod.letur) b.push('letur=' + o.slod.letur);
        b.push('fra=forsida');
        return rotSlod() + '/products/' + h + '?' + b.join('&');
      }
      var u = (f && f.getAttribute('data-url')) || '/collections/all';
      if (f && f.getAttribute('data-slod')) b.push(f.getAttribute('data-slod'));
      if (k === 'hus') {
        if (o.slod.litur) b.push('litur=' + o.slod.litur + '-' + (o.aferd || 'glans'));
        if (o.slod.staerd) b.push('staerd=' + o.slod.staerd);
      } else if (k === 'hotel') {
        if (o.slod.litur) b.push('litur=' + o.slod.litur);
        if (o.letur) b.push('letur=' + o.letur);
        /* [P1 23.10] HERBERGI · ROOM (undir=baedi í stillingu flipans) fylgir aðeins Nútímalegu; með Klassísku hafnar vörusíðan því á 14 x 14 og hero-ið sýnir það ekki heldur */
        if (o.letur === 'didot') b = b.filter(function (x) { return x.indexOf('undir=') !== 0; });
      } else if (k === 'gjof') {
        if (o.slod.staerd) b.push('staerd=' + o.slod.staerd);
        if (o.slod.litur) b.push('litur=' + o.slod.litur);
        /* letrið er vélarástand á vörusíðunni (ekki Shopify-valkostur): sm-vs-brusi.js les letur= */
        if (o.letur) b.push('letur=' + o.letur);
      }
      b.push('fra=forsida');
      return u + (u.indexOf('?') < 0 ? '?' : '&') + b.join('&');
    }

    /* stærðarlínan: frá vélinni, annars úr stillingu flipans ({v} = valin stærð, t.d. brúsinn) */
    function kvardiAf(k, V) {
      var f = flipiAf(k), o = val[k] || {};
      var t = (V && V.tilbuin() && V.kvardi) || (f && f.getAttribute('data-kvardi')) || '';
      return kvEn(t.replace('{v}', o.staerd || ''));
    }
    var bidur = false;
    function teikna() {
      bidur = false;
      var V = vel(virkur);
      if (!V || !V.tilbuin()) return;
      /* [bola] vélin mælir hylkið með getBoundingClientRect; meðan bólan er opin er lagið skalað (--bola-kvardi), svo hún teiknaði
         minni plötu, tilfærslan minnkaði og platan með, koll af kolli. Lagið er því mælt ótransformað meðan teiknað er (sama verk,
         engin málun á milli; transition slökkt svo skiptin hreyfist ekki) */
      var lagB = rot._hlBola ? lagAf(virkur) : null;
      if (lagB) { lagB.style.transition = 'none'; lagB.style.transform = 'none'; }
      try { V.teikna(gildi[virkur], val[virkur]); }
      finally { if (lagB) { lagB.style.transform = ''; raf(function () { lagB.style.transition = ''; }); } }
      villa = !!V.villa;
      var kt = kvardiAf(virkur, V);
      if (kvardiEl && kt && kvardiEl.textContent !== kt) kvardiEl.textContent = kt;
      syna();
      if (rot._hlBola) raf(rot._hlBola); /* [bola] platan mæld eftir hverja teikningu */
    }
    function seinna() { if (!bidur) { bidur = true; raf(teikna); } }
    rot._hlTeikna = seinna;

    function syna() {
      var f = flipiAf(virkur);
      var er = trim(gildi[virkur]).length > 0, simi = true; /* [hx] einn aðaltakki á öllum breiddum (áður aðeins sími, mq) */
      var tTexti = (f && f.getAttribute('data-takki')) || '';
      var bilun = !!hledstEkki[virkur];
      var iFlis = (er || bilun) && !villa && !(simi && takki && tTexti);
      afram.setAttribute('href', slodAf(virkur));
      if (aframTexti && aframTexti.textContent !== tTexti) aframTexti.textContent = tTexti;
      if (afram.hidden !== !iFlis) afram.hidden = !iFlis;
      var hj = villa ? (f.getAttribute('data-villa') || '') : (bilun ? (hjalp.getAttribute('data-hledst-ekki') || '') : (f.getAttribute('data-hjalp') || ''));
      if (hjalp.textContent !== hj) hjalp.textContent = hj;
      var synaHj = !iFlis || bilun;
      if (hjalp.hidden !== !synaHj) hjalp.hidden = !synaHj;
      reitur.setAttribute('aria-invalid', villa ? 'true' : 'false');
      rot.classList.toggle('is-nafn', er);
      if (!takki || !tTexti) return;
      var fyrsti = virkur === tabs[0].getAttribute('data-hl-tab');
      var nu = (er || !fyrsti) && simi && (!villa || !fyrsti); /* [hx] fylgir flipanum líka án innsláttar og þegar Hótel-númerið passar ekki (vörusíðan hefur fleiri stærðir) */
      /* [P1 23.10] aðaltakkinn ber ALLTAF slóð valsins (litur, lögun, rammi, stærð, letur; hús/hótel/gjöf sínar breytur), líka án nafns:
         áður fékk hurðarflipinn grunnslóðina þar til nafn var skrifað, svo valið tapaðist. Textinn skiptir eins og áður. */
      takki.setAttribute('href', afram.getAttribute('href'));
      if (nu) {
        takki.textContent = tTexti + ' ';
        var o = document.createElement('span');
        o.className = 'arrow'; o.setAttribute('aria-hidden', 'true'); o.innerHTML = '&rarr;';
        takki.appendChild(o);
      } else if (aTakka) {
        takki.innerHTML = grunnT;
      }
      aTakka = nu;
    }

    /* það sem var skrifað fer um localStorage, einn lykill á flipa (sjá efst); aldrei í slóð */
    function geyma() {
      var g = gildi[virkur], f = null;
      if (virkur === 'hurd') {
        var L = nofnAf(g), sk = !!(val.hurd && val.hurd.skraut);
        try { if (L.length || sk) window.localStorage.setItem(LYKILL, JSON.stringify({ n: L.join('\n'), s: sk ? 1 : 0, t: Date.now() })); } catch (e) {}
        return;
      }
      if (virkur === 'hus') { var x = lesaHus(g); if (x.numer || x.gata) f = { numer: x.numer, gata: x.gata }; }
      else if (virkur === 'hotel') { if (einLina(g)) f = { numer: einLina(g) }; }
      else if (virkur === 'gjof') { if (einLina(g)) f = { nafn: einLina(g) }; }
      if (!f || !LYKLAR[virkur]) return;
      f.t = Date.now();
      try { window.localStorage.setItem(LYKLAR[virkur], JSON.stringify(f)); } catch (e2) {}
    }
    ['click', 'auxclick', 'contextmenu'].forEach(function (n) {
      afram.addEventListener(n, geyma);
      if (takki) takki.addEventListener(n, geyma); /* [P1 23.10] alltaf: geyma skrifar aðeins ef eitthvað er skrifað */
    });

    function velja(i, fokus) {
      var t = tabs[i], k = t.getAttribute('data-hl-tab');
      gildi[virkur] = reitur.value;
      var fra = virkur;
      virkur = k;
      tabs.forEach(function (x, j) {
        var on = j === i;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        if (on && fokus) x.focus();
      });
      if (panel) panel.setAttribute('aria-labelledby', t.id);
      [].slice.call(svid.querySelectorAll('[data-hl-lag]')).forEach(function (l) { l.hidden = l.getAttribute('data-hl-lag') !== k; });
      [].slice.call(flis.querySelectorAll('[data-hl-val]')).forEach(function (l) { l.hidden = l.getAttribute('data-hl-val') !== k; });
      flis.setAttribute('data-hl-virkur', k);
      yfir();
      /* nafnið fer á milli Hurðar og Gjafar ef hinn reiturinn er tómur */
      if (!trim(gildi[k])) {
        if (k === 'gjof' && fra === 'hurd') gildi.gjof = nofnAf(gildi.hurd)[0] || '';
        else if (k === 'hurd' && fra === 'gjof') gildi.hurd = trim(gildi.gjof);
      }
      reitur.value = gildi[k] || '';
      if (heiti) heiti.textContent = t.getAttribute('data-heiti') || '';
      reitur.setAttribute('placeholder', t.getAttribute('data-ph') || '');
      reitur.setAttribute('enterkeyhint', k === 'hurd' ? 'enter' : 'done');
      villa = false;
      var V = vel(k);
      if (kvardiEl) kvardiEl.textContent = kvardiAf(k, V);
      syna();
      seinna();
      if (rot._hlBola) rot._hlBola(); /* [bola] bóla nýja flipans mæld */
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { if (t.getAttribute('aria-selected') !== 'true') velja(i, false); });
      /* vélin byrjar að hlaðast um leið og músin fer yfir flipann eða hann fær fókus */
      t.addEventListener('pointerenter', function () { vel(t.getAttribute('data-hl-tab')); });
      t.addEventListener('focus', function () { vel(t.getAttribute('data-hl-tab')); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, j = -1;
        if (e.key === 'ArrowRight') j = (i + 1) % n;
        else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = n - 1;
        if (j >= 0) { e.preventDefault(); velja(j, true); }
      });
    });

    reitur.addEventListener('keydown', function (e) {
      /* Hurð: Enter gefur nýja línu eins og nafnaboxið á vörusíðunni; hinir fliparnir eru ein lína */
      if (e.key === 'Enter' && virkur !== 'hurd') e.preventDefault();
    });
    reitur.addEventListener('input', function () {
      if (virkur !== 'hurd' && /\n/.test(reitur.value)) reitur.value = reitur.value.replace(/\s*\n\s*/g, ' ');
      gildi[virkur] = reitur.value;
      syna();
      seinna();
    });
    /* valkostaröðin: radio (efni/litur), pör (eitt valið), rofar (á/af) og hringir (smellur fer í næsta gildi) */
    function breyttVal(g) {
      var k = g.getAttribute('data-hl-val');
      lesaVal(k);
      syna();
      yfir();
      if (k === virkur) seinna();
    }
    [].slice.call(flis.querySelectorAll('[data-hl-val]')).forEach(function (g) {
      g.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio' && e.target.checked) breyttVal(g); });
      g.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('button') : null;
        if (!b || !g.contains(b)) return;
        var par = b.parentNode && b.parentNode.getAttribute && b.parentNode.getAttribute('data-hl-par') != null ? b.parentNode : null;
        if (par) {
          if (b.getAttribute('aria-pressed') === 'true') return;
          [].slice.call(par.querySelectorAll('button')).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        } else if (b.hasAttribute('data-hl-rofi')) {
          b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        } else if (b.hasAttribute('data-hl-hringur')) {
          var heiti = (b.getAttribute('data-heiti') || '').split(','), i = (+(b.getAttribute('data-i') || 0) + 1) % heiti.length;
          b.setAttribute('data-i', String(i));
          hringurTexti(b);
          /* nýja gildið sagt í aria-live raufinni */
          if (tilkynna) { tilkynna.textContent = ''; tilkynna.textContent = String(b.getAttribute('aria-label') || b.textContent).split('.')[0]; }
        } else return;
        breyttVal(g);
      });
    });
    /* hringurinn sýnir valið gildi (í sínu eigin letri ef það er vefletur) og segir skjálesara hvað smellur gerir */
    function hringurTexti(b) {
      var heiti = (b.getAttribute('data-heiti') || '').split(','), fj = (b.getAttribute('data-fjolsk') || '').split(','), i = +(b.getAttribute('data-i') || 0);
      b.textContent = heiti[i] || '';
      if (fj[i]) b.style.fontFamily = '"' + fj[i] + '", var(--font-body)';
      b.setAttribute('aria-label', String(b.getAttribute('data-aria') || '{v}').replace('{v}', heiti[i] || ''));
    }
    [].slice.call(flis.querySelectorAll('[data-hl-hringur]')).forEach(hringurTexti);
    /* sími: röð sem kemst ekki fyrir fær dofna brún þeim megin sem meira er að sjá (is-hm hægra, is-vm vinstra) */
    function yfir() {
      var g = valAf(virkur);
      if (!g) return;
      var y = g.scrollWidth > g.clientWidth + 2;
      g.classList.toggle('is-yfir', y);
      g.classList.toggle('is-hm', y && g.scrollLeft + g.clientWidth < g.scrollWidth - 2);
      g.classList.toggle('is-vm', y && g.scrollLeft > 2);
    }
    [].slice.call(flis.querySelectorAll('[data-hl-val]')).forEach(function (g) { g.addEventListener('scroll', yfir, { passive: true }); });
    window.addEventListener('resize', yfir);
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', syna); else if (mq.addListener) mq.addListener(syna); }
    /* til baka í vafranum (bfcache): reiturinn heldur gildinu */
    window.addEventListener('pageshow', function () { gildi[virkur] = reitur.value; syna(); seinna(); });
    if (window.ResizeObserver) new ResizeObserver(seinna).observe(svid);
    else window.addEventListener('resize', seinna);

    vel(virkur);
    syna();
    yfir();
    if (flis.hasAttribute('data-hl-bola')) bola();

    /* ================= [bola] glerbólan 22.10 (yfirferd/hero-bola-2026-10-22/): sama CSS og vörusíðurnar (sm-vs-bola.css), sömu
       eigindir og kittið (sm-vel-sida.js takkarSmida) setur, hér í stuttu máli fyrir hero-ið:
       tölva (1001 px+): --bola-topp-lokad/--bola-sy-lokad (lokuð bóla sýnir aðeins táknin), data-bola-thett og --bola-rod-max/data-bola-skrun
       ef bólan kemst ekki fyrir á veggnum, --bola-faersla/--bola-kvardi (skiltið rennur til vinstri meðan bólan er opin svo hún hylji það
       aldrei), Esc lokar (data-bola-lokud); engin kynning á forsíðunni (aðallota 23.10). Sími: glerhylkið skrunar lárétt (data-skrun/-endi).
       Engin breyting á stærð neins kassa (CLS 0): aðeins clip-path, transform og eigindir. ================= */
    function bola() {
      var rammi = flis.querySelector('[data-hl-rammi]');
      if (!rammi || !window.matchMedia) return;
      /* tölvubólan er 1200 px+; 1001-1199 og sími fá símahylkið (sm-hero-bola.css), þá er data-takkar-bola tekin af flísinni svo tölvureglur
         sm-vs-bola.css gildi ekki (við þáttun gerir inline-skrifta í sniðmátinu það, hér við breytta breidd) */
      var mq = window.matchMedia('(min-width: 1200px)'), mqMid = window.matchMedia('(min-width: 1001px) and (max-width: 1199px)'), BOLA_OPIN = 192, BOLA_BIL = 12, faersla = { s: 1, dx: 0 }, bidurB = false;
      var midStada = function () { if (mqMid.matches) flis.removeAttribute('data-takkar-bola'); else if (!flis.hasAttribute('data-takkar-bola')) flis.setAttribute('data-takkar-bola', ''); };
      midStada();
      if (mqMid.addEventListener) mqMid.addEventListener('change', midStada); else if (mqMid.addListener) mqMid.addListener(midStada);
      function barinn() { return rammi.querySelector('.vs-hurd-takkar:not([hidden])'); }
      function mal() {
        var bar = barinn();
        if (!bar || !mq.matches) return;
        var inni = bar.querySelector('.vs-bola-inni'), rod = bar.querySelector('.vs-takkar-rod');
        if (!inni || !rod) return;
        var cs = getComputedStyle(bar), bil = (parseFloat(cs.top) || 0) + (parseFloat(cs.bottom) || 0);
        bar.removeAttribute('data-bola-thett'); rod.removeAttribute('data-bola-skrun'); rod.style.removeProperty('--bola-rod-max');
        var maxAf = function () { return Math.floor(rammi.clientHeight - bil - (inni.offsetHeight - rod.clientHeight)); };
        var max = maxAf(), yfirB = max > 80 && rod.scrollHeight > max + 2;
        if (yfirB) { bar.setAttribute('data-bola-thett', ''); max = maxAf(); yfirB = rod.scrollHeight > max + 2; }
        if (yfirB) { rod.style.setProperty('--bola-rod-max', max + 'px'); rod.setAttribute('data-bola-skrun', ''); }
        var h = bar.offsetHeight, topp = Math.max(0, rod.offsetTop - 10);
        if (!h) return;
        var t = topp + 'px', sy = String(Math.round((h - topp) / h * 1000) / 1000);
        if (bar.style.getPropertyValue('--bola-topp-lokad') !== t) bar.style.setProperty('--bola-topp-lokad', t);
        if (bar.style.getPropertyValue('--bola-sy-lokad') !== sy) bar.style.setProperty('--bola-sy-lokad', sy);
      }
      /* platan (eða teikningin) mæld án tilfærslunnar: hlutföll innan lagsins, lagið sjálft er alltaf kassi sviðsins */
      function plataRect() {
        var lag = svid.querySelector('[data-hl-lag]:not([hidden])');
        if (!lag) return null;
        var p = lag.querySelector('.vs-hurd-plata, .hn-plata:not([hidden]), [data-hl-vel]:not([hidden]) > svg, [data-hl-kyrr]:not([hidden])');
        if (!p) return null;
        var sr = svid.getBoundingClientRect(), lr = lag.getBoundingClientRect(), s = lr.width ? lr.width / sr.width : 1, pr = null;
        if (p.tagName && p.tagName.toLowerCase() === 'svg' && p.getBBox && p.getScreenCTM) {
          try {
            var bb = p.getBBox(), m = p.getScreenCTM();
            if (bb.width && m) {
              var xs = [m.a * bb.x + m.c * bb.y + m.e, m.a * (bb.x + bb.width) + m.c * bb.y + m.e, m.a * bb.x + m.c * (bb.y + bb.height) + m.e, m.a * (bb.x + bb.width) + m.c * (bb.y + bb.height) + m.e];
              var x1 = Math.min.apply(null, xs), x2 = Math.max.apply(null, xs);
              pr = { left: x1, width: x2 - x1 };
            }
          } catch (e) { pr = null; }
        }
        if (!pr) { var r = p.getBoundingClientRect(); if (!r.width) return null; pr = { left: r.left, width: r.width }; }
        return { left: sr.left + (pr.left - lr.left) / s, width: pr.width / s, ox: sr.left, right: sr.right };
      }
      function plass() {
        bidurB = false;
        if (!mq.matches) return;
        var bar = barinn(), p = plataRect();
        if (!bar || !p) return;
        var haegri = p.right - 20 - (bar.offsetWidth || BOLA_OPIN) - BOLA_BIL, vinstri = p.ox + 16, pl = p.left, pw = p.width, ny = { s: 1, dx: 0 };
        if (pw > 0 && pl + pw > haegri) {
          if (pw <= haegri - vinstri) ny.dx = Math.max(haegri - (pl + pw), vinstri - pl);
          else { ny.s = (haegri - vinstri) / pw; ny.dx = vinstri - p.ox - (pl - p.ox) * ny.s; }
        }
        ny.s = Math.round(ny.s * 1000) / 1000; ny.dx = Math.round(ny.dx);
        if (ny.s !== faersla.s || ny.dx !== faersla.dx) {
          faersla = ny;
          rammi.style.setProperty('--bola-faersla', ny.dx + 'px');
          rammi.style.setProperty('--bola-kvardi', String(ny.s));
        }
      }
      function skrun() {
        var bar = barinn(), rod = bar && bar.querySelector('.vs-takkar-rod');
        if (!rod || mq.matches) return;
        var s = rod.scrollWidth > rod.clientWidth + 2, endi = s && rod.scrollLeft + rod.clientWidth >= rod.scrollWidth - 2;
        if (rod.hasAttribute('data-skrun') !== s) { if (s) rod.setAttribute('data-skrun', ''); else rod.removeAttribute('data-skrun'); }
        if (rod.hasAttribute('data-skrun-endi') !== endi) { if (endi) rod.setAttribute('data-skrun-endi', ''); else rod.removeAttribute('data-skrun-endi'); }
      }
      function allt() { mal(); plass(); skrun(); }
      rot._hlBola = function () { if (!bidurB) { bidurB = true; raf(allt); } };
      [].slice.call(rammi.querySelectorAll('.vs-takkar-rod')).forEach(function (r) { r.addEventListener('scroll', skrun, { passive: true }); });
      if (mq.addEventListener) mq.addEventListener('change', rot._hlBola); else if (mq.addListener) mq.addListener(rot._hlBola);
      window.addEventListener('resize', rot._hlBola);
      if (window.ResizeObserver) new ResizeObserver(rot._hlBola).observe(svid);
      /* Esc lokar opinni bólu (mús yfir eða fókus í henni) þar til músin eða fókusinn fer */
      document.addEventListener('keydown', function (e) {
        if ((e.key !== 'Escape' && e.key !== 'Esc') || !mq.matches) return;
        var bar = barinn(); if (!bar) return;
        bar.removeAttribute('data-kynning');
        var yfirM = false;
        try { yfirM = bar.matches(':hover'); } catch (e2) {}
        if (yfirM || bar.contains(document.activeElement)) bar.setAttribute('data-bola-lokud', '');
      });
      rammi.addEventListener('mouseleave', function () { var b = barinn(); if (b && !b.contains(document.activeElement)) b.removeAttribute('data-bola-lokud'); });
      rammi.addEventListener('focusout', function (e) { var b = barinn(); if (b && (!e.relatedTarget || !b.contains(e.relatedTarget))) b.removeAttribute('data-bola-lokud'); });
      /* engin kynning (3 s opnun) á forsíðunni (aðallota 23.10): hún er aðeins á vörusíðunum (kittið) */
      allt();
    }
  }

  function heroar() {
    [].slice.call(document.querySelectorAll('[data-hl]')).forEach(function (rot) {
      if (rot.__smHl) return;
      rot.__smHl = true;
      hero(rot);
    });
  }
  function byrja() {
    /* einkunnin í traustlínunni tengir á umsagnakaflann */
    var umsagnir = document.querySelector('.testimonials');
    if (umsagnir && !umsagnir.id && !document.getElementById('umsagnir')) umsagnir.id = 'umsagnir';
    heroar();
  }
  /* Hraði 23.10.2026 (eins og sm-hero-lifandi.js 19.10): skriftin stendur á eftir kaflanum (ekki defer), svo hero byrjar strax;
     umsagnamarkið og hero sem kæmu síðar í skjalinu bíða DOMContentLoaded. Hver hero byrjar aðeins einu sinni. */
  if (document.readyState === 'loading') {
    heroar();
    document.addEventListener('DOMContentLoaded', byrja);
  } else byrja();
})();
